import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  summary: {
    textAlign: 'center',
    alignItems: 'center',
  },
  mapWrapper: {
    [theme.breakpoints.between('sm', 'md')]: {
      pointerEvents: 'none',
    },
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1em',
    animationDelay: '0.3s',
    animationFillMode: 'backwards',
    marginBottom: theme.spacing(2),
    position: 'relative',
    [theme.breakpoints.between('sm', 'md')]: {
      marginTop: theme.spacing(12),
    },
  },
  headline: {
    marginTop: theme.spacing(-12),
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-12),
      padding: theme.spacing(0, 4),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-8),
      padding: theme.spacing(0, 2),
    },
  },
  status: {
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-2),
      marginBottom: theme.spacing(2),
    },
  },
  actions: {
    position: 'absolute',
    right: 0,
    top: 96,
    padding: theme.spacing(2),
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
      top: 72,
    },
    [theme.breakpoints.down('sm')]: {
      top: 48,
    },
  },
  vanityUrl: {
    position: 'absolute',
    right: 0,
    top: 150,
    padding: theme.spacing(2),
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
      top: 126,
    },
    [theme.breakpoints.down('sm')]: {
      top: 75,
    },
  },
  introduction: {
    maxWidth: 900,
    boxSizing: 'border-box',
    padding: theme.spacing(0, 3),
    margin: `${theme.spacing(2)} auto`,
    textAlign: 'center',
    animationDelay: '0.4s',
    animationFillMode: 'backwards',
    [theme.breakpoints.down('md')]: {
      fontStyle: 'normal',
      textAlign: 'left',
      margin: '0 auto',
    },
  },
  divider: {
    margin: `${theme.spacing(3)} ${theme.spacing(-2)} !important`,
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    },
  },
  specializations: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(4, 0),
    },
  },
  editableRateFields: {
    marginTop: theme.spacing(1),
  },
  error: {
    marginTop: theme.spacing(1),
  },
}))
